export const footer = {
  openingHours: 'Mo-Fr 9-17 Uhr',
  contactForm: 'Kontaktformular',
  block1Title: 'HausHeld.ch',
  block1Link1: `So Funktioniert's`,
  block1Link2: 'Ihre Vorteile',
  block1Link3: 'HausHeld-Versprechen',
  block1Link4: 'myHausHeld',
  block1Link5: 'Kunden',
  block2Title: 'Ratgeber',
  block2Link1: 'Zentrale Aspekte',
  block2Link2: 'Energie & Effizienz',
  block2Link3: 'Komfort & Qualität',
  block2Link4: 'Geld & Finanzen',
  block2Link5: 'Fachwissen & Mehr',
  block3Title: 'Für Handwerker',
  block3Link1: 'Jetzt Partner werden!',
  block3Link2: 'Ihre Vorteile',
  block3Link3: 'Mehr Kundenanfragen!',
  block3Link4: 'Partner FAQs',
  block4Title: 'Über Uns',
  block4AufzugoLink1: 'Die Experten',
  block4Link1: 'Erste Eindrücke',
  block4AufzugoLink2: 'Zitate',
  block4Link2: 'Das Team',
  block4Link3: 'HausHeld Universum',
  block4Link4: 'FAQs',
  block5Title: 'Kontakt',
  block5Link1: 'Kontaktdetails',
  block5Link2: 'Kontaktformular',
  block6Title: 'Login',
  block6Link1: 'Login für Partner',
  block6Link2: 'Login myHausHeld',
  copyright: 'HausHeld ©',
  copyrightAufzugo: 'Aufzugo ©',
  copyrightVermando: '. Eine Marke der Vermando AG. Alle Rechte vorbehalten.',
  conditions: 'AGB',
  dataProtection: 'Datenschutz',
  legalNotice: 'Impressum',
  cookieSettings: 'Cookie-Einstellungen',
  becomePartner: 'Partner werden',
}
